<template>
  <div class="foot">
    <div class="bodyCenter">
      <div class="topItem">
        <div class="title">{{ $t('footer.titleTop') }}</div>
        <div class="title">{{ $t('footer.titleBottom') }}</div>
        <div class="box">
          <div class="item" v-for="(item, index) in exhibition" :key="index">
            <img :src="item.iconImg" alt="" class="img" />
            <span>{{ item.text }}</span>
          </div>
        </div>
      </div>
      <div class="bottomItem">
        <div class="box">
          <div class="img"><img src="../../static/erweiMa.png" alt="" /></div>
          <p>{{ $t('footer.mobileQrCodeAttention') }}</p>
        </div>
      </div>
    </div>

    <div class="fixedFoot">
      <div class="center">
        <div class="content">{{ $t('footer.copyright') }}</div>
        <div class="content">{{ $t('footer.technicalSupport') }}</div>
        <div class="content">{{ $t('footer.spareNumber1') }} &nbsp;&nbsp;&nbsp;{{ $t('footer.spareNumber2') }}</div>
        <div class="content">Copyright © 2018. All Rights Reserved</div>
      </div>
    </div>
    <div class="backTop" @click="backTop" v-if="topBtn">
      <img src="../../static/backTop.png" alt="" />
    </div>
  </div>
</template>

<script>
import { viewcz, viewcg, zwt, zhrc, hzZhanhui } from '../../../utils/common.js';
export default {
  name: 'footBottom',
  data() {
    return {
      exhibition: [
        { iconImg: require('../../static/address.png'), text: this.$t('footer.address') },
        { iconImg: require('../../static/email.png'), text: 'chinaminexpo@vip.163.com' },
        { iconImg: require('../../static/phone.png'), text: '0086 10 64253061' },
        { iconImg: require('../../static/icon_web.png'), text: 'www.chinaminexpo.com' },
      ],
      topBtn: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    backTop() {
      document.documentElement.scrollTop = 0;
      window.scrollTo(0, 0);
    },
    handleScroll() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        this.topBtn = true;
      } else {
        this.topBtn = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.foot {
  width: 100vw;
  position: relative;
  background-image: url('../../static/backImg.png');
  background-position: center;
  background-size: cover;
  .bodyCenter {
    justify-content: space-between;
    padding: 6.9vw 3.8vw 6.5vw;
    box-sizing: border-box;

    .topItem {
      .title {
        font-size: 4.3vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 6.4vw;
      }
      .box {
        margin-top: 8vw;
        .item {
          display: flex;
          margin-top: 4vw;
          .img {
            width: 3.2vw;
            height: 3.2vw;
            margin-right: 2vw;
            justify-content: center;
            align-items: center;
            display: flex;
            img {
              max-width: 100%;
              max-height: 100%;
              vertical-align: middle;
            }
          }
          span {
            font-size: 3.2vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 3.5vw;
          }
        }
      }
    }
    .bottomItem {
      width: 100%;
      margin-top: 9vw;
      .box {
        text-align: center;
        .img {
          width: 34.67vw;
          height: 34.67vw;
          margin-bottom: 2vw;
          margin: 0 auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
        p {
          font-size: 3.7vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 3.2vw;
          margin-top: 4vw;
        }
      }
    }
  }

  .fixedFoot {
    width: 100vw;
    // height: 33.6vw;
    background: #000000;
    opacity: 0.6;
    text-align: center;
    padding: 6.6vw 8vw;
    box-sizing: border-box;
    .content {
      font-size: 3.2vw;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #a4cdff;
      margin-top: 0.6vw;
    }
  }
  .backTop {
    position: fixed;
    bottom: 20.3vw;
    right: 4vw;
    width: 9.6vw;
    height: 9.6vw;
    background: #fdd000;
    border-radius: 1.3vw;
    padding: 2.6vw;
    box-sizing: border-box;
    text-align: center;
    z-index: 99;
    img {
      width: 4vw;
    }
  }
}
</style>
